import tw from 'tailwind-styled-components';

const Marker = tw.div`
    h-3
    w-3
    bg-tt-emerald-500
    rounded-full
`;

export default Marker;